import React from 'react'
import { useActions, useValues } from 'kea'

import I18n from 'lib/i18n'

import sceneLogic from '~/scenes/pages/request/logic'

const TRANSLATIONS = {
  infant: I18n.t('react.search.filters.age.infant'),
  preschool: I18n.t('react.search.filters.age.preschool'),
  child: I18n.t('react.search.filters.age.child'),
  teenager: I18n.t('react.search.filters.age.teenager'),
  adult: I18n.t('react.search.filters.age.adult'),
  senior: I18n.t('react.search.filters.age.senior')
}

const StudentAge = () => {
  const { nextPage, setStudentAge } = useActions(sceneLogic)
  const { studentAge } = useValues(sceneLogic)

  const saveStudentAgeAndProceed = studentAge => {
    setStudentAge(studentAge)
    nextPage()
  }

  return (
    <div className='list-choice'>
      <h1>{I18n.t('react.request.student_age.title')}</h1>
      <ul className='clickable-list'>
        {Object.keys(TRANSLATIONS).map(key => (
          <li
            key={key}
            onClick={() => saveStudentAgeAndProceed(key)}
            className={studentAge === key ? 'selected' : null}
          >
            {TRANSLATIONS[key]}
          </li>
        ))}
      </ul>
    </div>
  )
}

export default StudentAge
